import { CreateTicketDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { trackCreateTicket } from 'modules/ticketing/lib/tracking'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

const useCreateTicketActionResolver: OneCreationActionResolver = () => {
  const { company } = useCurrentSession()

  const [createTicket, { loading }] = useMutation(CreateTicketDocument, {
    extractorFn: (data) => data.ticketingMutations.createTicketingTicket,
    errorPolicy: 'all',
  })

  const createTicketHandler = async (args: {
    title: string
    description: string
    categoryId: string
    categoryName?: string
    priority?: string
  }) => {
    const result = await createTicket({
      variables: {
        companyId: company.id,
        title: args.title,
        description: args.description,
        priority: args.priority,
        categoryId: args.categoryId,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      trackCreateTicket({
        priority: args.priority ?? 'medium',
        has_description: (args.description ?? '').trim().length > 0,
        has_attachments: false,
        attachments_count: 0,
        origin: 'one',
        has_ai_enhanced_description: false,
      })
      return { success: true as const, data: args }
    }

    return handled
  }

  return {
    resolver: createTicketHandler,
    loading,
  }
}

export const CreateTicketAction: OneCreateAction = {
  actionResolver: useCreateTicketActionResolver,
  policies: ['Ticketing_aiFeatures'],
}
